import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Form } from '../form/form-helpers/form';
import { IFormModel } from '../form/form.model';
import { InputType } from '../form/input-type.enum';

@Component({
  selector: 'app-search-form',
  templateUrl: './search-form.component.html',
})
export class SearchFormComponent<T> extends Form<T> implements OnInit {
  @ViewChild('searchInput') searchInput: ElementRef | undefined;
  @Output() emitSearch = new EventEmitter<string>();
  @Output() emitClear = new EventEmitter<any>();

  constructor() {
    super();
  }

  input = {
    name: 'search',
    type: InputType.Text,
    placeholder: 'overview.search',
  } as IFormModel;

  ngOnInit(): void {
    this.registerComponents([this.input]);
  }

  onSearch() {
    if (!this.getValueForControl('search')) return;
    this.emitSearch.emit(this.getValueForControl('search'));
  }

  onClear() {
    this.setValueForControl('search', null);
    this.emitClear.emit();
  }
}
